export type WizardStepActions = {
  endTour: boolean;
  back: boolean;
  next: boolean;
  done: boolean;
};

export function getWizardStepActions(
  stepIndex: number,
  totalSteps: number,
): WizardStepActions {
  if (totalSteps <= 0) {
    return { endTour: false, back: false, next: false, done: false };
  }

  if (totalSteps === 1) {
    return { endTour: false, back: false, next: false, done: true };
  }

  const isFirst = stepIndex === 0;
  const isLast = stepIndex === totalSteps - 1;

  if (isFirst) {
    return { endTour: true, back: false, next: true, done: false };
  }

  if (isLast) {
    return { endTour: false, back: true, next: false, done: true };
  }

  return { endTour: true, back: true, next: true, done: false };
}
